const TOTAL_PHOTOS = 22;

export const NEEMUCH_GALLERY = Array.from({ length: TOTAL_PHOTOS }, (_, i) => {
  const num = String(i + 1).padStart(2, "0");
  return {
    id: `neemuch-${num}`,
    imgurl: `/images/gallery/neemuch/neemuch-gallery-${num}.jpeg`,
    img_title: "Second Home - Neemuch",
  };
});
